export enum UserStatusEnum {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export enum UserRoleEnum {
  ADMIN = 'admin',
  EMPLOYEE = 'employee',
  SUPER_ADMIN = 'super_admin',
}
